/**
 * Valida um formulário baseado nos atributos dos inputs, selects, e textareas do formulário
 * @example var valido = $('form').validate();
 * @param {string[]} ignore Lista de names de inputs para serem ignorados
 * @param {string} parentSelector Seletor do parente em relação ao input que receberá a classe de erro
 * @return {boolean} Se está válido ou não
 */
$.fn.validate = function (ignore, parentSelector) {
	ignore = Array.isArray(ignore) ? ignore : [];

	const $inputs = $(this).find('input, select, textarea');
	let valid = true;

	if (parentSelector) {
		$inputs.closest(parentSelector).removeClass('error');
	} else {
		$inputs.removeClass('error');
	}

	$inputs.each((i, el) => {
		if (!valid) return;

		const $el = $(el);
		if (ignore.indexOf($el.attr('name')) > -1) return;

		const val = ($el.val() || '').trim();

		const minlength = $el.attr('minlength');
		const maxlength = $el.attr('maxlength');
		const required = typeof $el.attr('required') !== 'undefined';

		if (
			minlength && val.length < minlength ||
			maxlength && val.length > maxlength ||
			required && val.length == 0
		) {
			if (parentSelector) {
				$el.closest(parentSelector).addClass('error');
			} else {
				$el.addClass('error');
			}

			$el.focus();
			valid = false;
		}
	});

	return valid;
}
